import React from 'react';
import {
  useCompaniesQuery,
  companiesSelectors,
} from '../../../../api/companies';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import {
  useSearchParamsSelector,
  useSearchParamsMethods,
} from '../../../../shared/packages/searchParamsManager';
import {
  resettableParams,
  searchParamKeys,
} from '../../../../shared/configs/searchParams';
import Control from './Control';
import { toInteger } from '../../../../shared/packages/searchParamsNormalizer';

const companyParam = searchParamKeys.company;

const SelectCompany = ({ disabled }) => {
  const currentCompanyId = useSearchParamsSelector((state) => {
    return toInteger(state[companyParam]);
  });

  const { setParams } = useSearchParamsMethods();

  const { data, isFetching } = useCompaniesQuery({
    options: { select: companiesSelectors.toSelectOption },
  });

  const handleChange = (value) =>
    setParams({
      [companyParam]: value,
      [searchParamKeys.acceptance]: undefined,
      ...resettableParams,
    });

  return (
    <DropdownSelect
      options={data}
      value={getValue({ loading: isFetching, companyId: currentCompanyId })}
      onChange={handleChange}
      renderControl={renderControl}
      loading={isFetching}
      disabled={disabled}
    />
  );
};

export default SelectCompany;

function renderControl(props) {
  return <Control {...props} />;
}

function getValue({ loading, companyId }) {
  if (loading || companyId === undefined || companyId === 0) return;
  return companyId;
}
